import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Clock } from "lucide-react";
import api from "@/lib/api";
import { usePageMeta } from "@/lib/seo";
import { NewsletterBox } from "@/components/NewsletterBox";

export default function Blog() {
  usePageMeta(
    "Blog — Guide e consigli sui debiti | Sdebitiamoci Srl",
    "Guide pratiche su saldo e stralcio, debiti, pignoramenti e aste: i consigli di Sdebitiamoci Srl per uscire dai debiti in modo consapevole."
  );
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cat, setCat] = useState("Tutti");

  useEffect(() => {
    api.get("/blog").then(r => setPosts(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const categories = ["Tutti", ...Array.from(new Set(posts.map(p => p.category)))];
  const visible = cat === "Tutti" ? posts : posts.filter(p => p.category === cat);

  const fmtD = (iso) => new Date(iso).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" });

  return (
    <div className="pt-32 pb-24" data-testid="blog-page">
      <section className="container-editorial">
        <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-[#2d6fc4]">— Blog</p>
        <h1 className="font-serif text-4xl md:text-6xl leading-[0.95] mt-4 text-[#2d6fc4]">
          Guide e consigli<br/><em className="italic">per uscire dai debiti.</em>
        </h1>
        {!loading && posts.length > 0 && (
          <div className="mt-10 flex flex-wrap gap-2" data-testid="blog-filters">
            {categories.map(c => (
              <button key={c} onClick={() => setCat(c)}
                data-testid={`blog-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
                className={`px-4 py-2 rounded-full text-xs font-medium border ${cat === c
                  ? "bg-[#14417B] text-white border-[#14417B]"
                  : "bg-white text-[#2d6fc4] border-[#E5E7EB] hover:border-[#2d6fc4]"}`}
                style={{ transition: "background-color 200ms ease, border-color 200ms ease" }}>
                {c}
              </button>
            ))}
          </div>
        )}
        <div className="mt-10">
          {loading && <p className="text-[#333333]">Caricamento…</p>}
          {!loading && posts.length === 0 && (
            <p className="text-[#333333]" data-testid="blog-empty">I primi articoli sono in arrivo. Torna a trovarci presto!</p>
          )}
          {!loading && posts.length > 0 && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {visible.map((p, i) => (
                <motion.div key={p.slug}
                  initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.05 }}>
                    <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}
                    className="block border border-[#E5E7EB] bg-white rounded-lg overflow-hidden h-full hover:border-[#2d6fc4]"
                    style={{ transition: "border-color 200ms ease" }}>
                    {p.image && <img src={p.image} alt={p.title} loading="lazy" className="w-full aspect-[3/2] object-cover"/>}
                    <div className="p-8">
                    <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#2d6fc4]">{p.category} · {fmtD(p.published_at)}</p>
                    <h2 className="font-serif text-2xl md:text-3xl mt-3 text-[#2d6fc4] leading-tight">{p.title}</h2>
                    <p className="mt-4 text-sm text-[#333333] leading-relaxed">{p.excerpt}</p>
                    <p className="mt-6 text-xs text-[#333333] flex items-center gap-4">
                      <span className="flex items-center gap-1"><Clock size={12}/> {p.reading_minutes} min di lettura</span>
                      <span className="text-[#2d6fc4] inline-flex items-center gap-1">Leggi <ArrowUpRight size={12}/></span>
                    </p>
                    </div>
                  </Link>
                </motion.div>
              ))}
            </div>
          )}
        </div>
        <NewsletterBox />
      </section>
    </div>
  );
}
